import { Suspense } from 'react'

import useCurrentUser from 'web-client/hooks/useCurrentUser'
import lazyRetry from 'shared/utils/lazyRetry'
import type { HeaderProps } from './LoggedIn/Header'
import LogoOnlyHeader from './LogoOnlyHeader'

const LoggedInHeader = lazyRetry(() => import('./LoggedIn/Header'))

const Header = (props: HeaderProps) => {
  const { isLoading, isLoggedIn } = useCurrentUser()

  const loggedOutHeader = <LogoOnlyHeader useSwoopLogo />

  if (isLoading || !isLoggedIn) {
    return loggedOutHeader
  }

  return (
    <Suspense fallback={loggedOutHeader}>
      <LoggedInHeader {...props} />
    </Suspense>
  )
}

export default Header
